import { render, staticRenderFns } from "./EditorPreview.vue?vue&type=template&id=3604036f"
import script from "./EditorPreview.vue?vue&type=script&lang=js"
export * from "./EditorPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3604036f')) {
      api.createRecord('3604036f', component.options)
    } else {
      api.reload('3604036f', component.options)
    }
    module.hot.accept("./EditorPreview.vue?vue&type=template&id=3604036f", function () {
      api.rerender('3604036f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/components/EditorPreview.vue"
export default component.exports